import React from "react";
import { AuthForm } from "../../components";

const Login = () => {
  return <AuthForm type="login" />;
};

export default Login;
